module.exports = require('lodash').flip